module.exports = __webpack_public_path__ + "img/mastercard.d7e17d8d.svg";